module.exports = __webpack_public_path__ + "img/2_1-finanziario-ristorante-1.d787784d.png";